import { PLATFORM_SHELL_CLASSNAME } from '@unifyapps/style/themes/consts';
import { useMemo } from 'react';

/**
 * Theme override for platform chrome that must render platform-themed regardless of
 * where it mounts (block pickers, placeholder popovers, sidenav flyout panels).
 *
 * The platform root layout puts PLATFORM_SHELL_CLASSNAME on <body> only when the
 * platform theme is not overridden (see apps/platform/src/app/layout.tsx). Mirror
 * that decision here: re-apply the shell class only when body carries it; when the
 * theme is overridden return no class so the override cascade from body wins.
 * Reads the DOM directly — safe because consumers only attach the class to
 * interaction-gated portals, which never render during SSR.
 */
export function usePlatformThemeOverride() {
  const hasPlatformShell =
    typeof document !== 'undefined' && document.body.classList.contains(PLATFORM_SHELL_CLASSNAME);

  return useMemo(
    () => ({ themeOverrideClassName: hasPlatformShell ? PLATFORM_SHELL_CLASSNAME : '' }),
    [hasPlatformShell],
  );
}
